/**
 * «Вспомнить пароль» — выслать участку его логин и пароль на подключённый канал.
 *
 * Открывается МОДАЛКОЙ (общий components/Modal, рендерится порталом в body — работает
 * и на странице входа, и в ЛК). Триггер зависит от места:
 *   mode="login"   — на странице входа: ТЕКСТОВАЯ ССЫЛКА под кнопкой «Вход».
 *                    В модалке спрашиваем НОМЕР УЧАСТКА + кнопки каналов.
 *                    POST /api/auth/recall-password { area_number, channel } (публично).
 *   mode="profile" — в личном кабинете: КНОПКА над блоком «Telegram».
 *                    В модалке только кнопки каналов (номер участка из сессии).
 *                    POST /api/lk/recall-password { channel }.
 *
 * После успешной отправки форма в модалке заменяется на сообщение об успехе и кнопку
 * «Закрыть» (окно не закрывается само — человек читает, куда ушёл пароль, и закрывает сам).
 * Бекенд (Services\PasswordRecall) проверяет участок и подключённость канала; пароль в
 * ответе не приходит — уходит только по каналу.
 */

import { useState } from 'react'

import { api, ApiError } from '@/api/client'
import { Modal } from '@/components/Modal'

const CHANNELS = [
  { key: 'push', label: 'Push' },
  { key: 'telegram', label: 'Telegram' },
  { key: 'max', label: 'Max' },
  { key: 'email', label: 'Email' },
] as const

export function RecallPassword({ mode }: { mode: 'login' | 'profile' }) {
  const [open, setOpen] = useState(false)
  const [areaNumber, setAreaNumber] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState<string | null>(null) // успех — показываем в модалке
  const [error, setError] = useState<string | null>(null)

  const openModal = (): void => {
    setSent(null)
    setError(null)
    setAreaNumber('')
    setOpen(true)
  }

  const send = async (channel: string): Promise<void> => {
    if (mode === 'login' && areaNumber.trim() === '') {
      setError('Укажите номер участка')
      return
    }
    setBusy(true)
    setError(null)
    try {
      const path = mode === 'login' ? '/api/auth/recall-password' : '/api/lk/recall-password'
      const body =
        mode === 'login' ? { area_number: areaNumber.trim(), channel } : { channel }
      const result = await api.post<{ message: string }>(path, body)
      setSent(result.message) // форму скрываем, показываем успех + «Закрыть»
    } catch (e: unknown) {
      setError(e instanceof ApiError ? e.message : 'Не удалось отправить')
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      {/* Триггер: на входе — ссылка по центру под кнопкой «Вход», в ЛК — кнопка. */}
      {mode === 'login' ? (
        <p style={{ textAlign: 'center', marginTop: 10 }}>
          <a style={{ cursor: 'pointer' }} onClick={openModal}>
            Вспомнить пароль
          </a>
        </p>
      ) : (
        // Тот же легаси-класс, что у «Сменить пароль» (.changepasswordbtn) — для одинакового
        // РАЗМЕРА кнопок. Цвет оставляем синим (btn-info) инлайном: он бьёт и класс, и :hover.
        <div
          className="changepasswordbtn"
          onClick={openModal}
          style={{ backgroundColor: '#5bc0de', borderColor: '#46b8da', color: '#fff' }}
        >
          Вспомнить пароль
        </div>
      )}

      <Modal open={open} onClose={() => setOpen(false)} title="Вспомнить пароль">
        {sent !== null ? (
          // Успех: только сообщение и «Закрыть».
          <>
            <p style={{ color: 'green' }}>{sent}</p>
            <button type="button" className="btn btn-default" onClick={() => setOpen(false)}>
              Закрыть
            </button>
          </>
        ) : (
          <>
            {error !== null && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}

            {mode === 'login' && (
              <input
                className="form-control"
                placeholder="Номер участка"
                value={areaNumber}
                onChange={(e) => setAreaNumber(e.target.value)}
                style={{ marginBottom: 12 }}
              />
            )}

            <p style={{ marginBottom: 6 }}>Отправить логин и пароль:</p>
            {CHANNELS.map((channel) => (
              <button
                key={channel.key}
                type="button"
                className="btn btn-info"
                disabled={busy}
                onClick={() => void send(channel.key)}
                style={{ marginRight: 6, marginBottom: 6 }}
              >
                {channel.label}
              </button>
            ))}
          </>
        )}
      </Modal>
    </>
  )
}
